module.exports = __webpack_public_path__ + "media/assets/images/ikkatsu-mitsumori-img-4f25c422d469b590aa8100dff4e11dac.svg";